import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const ScrollToTopButton = ({ className = "", showAt = 200, icon = "↑" }) => {
  const [visible, setVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > showAt);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [showAt]);

  if (!visible) return null;
  if (typeof document === "undefined") return null;

  return createPortal(
    <button
        type="button"
      onClick={scrollToTop}
      className={`
        fixed sm:bottom-6 bottom-16 right-4 sm:right-6
        w-8 h-8 sm:w-12 sm:h-12
        bg-red-600 text-white
        rounded-full
        shadow-lg
        hover:bg-red-700
        transition
        flex items-center justify-center
        z-[2147483647]
        pointer-events-auto
        ${className}
      `}
      aria-label="Scroll to top"
    >
      {icon}
    </button>,
      document.body,
  );
};

export default ScrollToTopButton;
